import Backbone from 'backbone';

var Survey_Question = Backbone.Model.extend({
    defaults: {
        id                           : 0,
        account_id                   : 0,
        project_id                   : 0,
        survey_id                    : 0,
        question_key                 : '',
        page_number                  : 0,
        question_type                : 'short',
        question_sub_type            : '',
        question_label               : '',
        question_desc                : '',
        question_options             : '',
        question_sort                : 0,
        is_required                  : false,
        logo_url                     : '',
        button_text                  : '',
        hint_text                    : '',
        character_limit              : '',
        is_number                    : false,
        answer_layout                : '',
        is_multiple_select           : false,
        scale                        : 0,
        scale_label                  : '',
        answer_order                 : '',
        other_answer_type            : '',
        other_answer_hint_text       : '',
        other_answer_character_limit : '',
    },

    getLabel: function(escape) {
        if (escape) {
            return this.escape('question_label') || 'Type your question here…';
        } else {
            return this.get('question_label') || 'Type your question here…';
        }
    },

    getName: function() {
        switch (this.get('question_type')) {
            case 'welcome':
                return 'Intro';
            case 'dropdown':
                return 'Dropdown';
            case 'yesno':
                return 'Yes or No';
            case 'multiple':
                return 'Multiple Choice';
            case 'nps':
                return 'Net Promoter Score&#174;';
            case 'rating':
                if (this.get('question_sub_type') === 'star') {
                    return 'Stars';
                } else if (this.get('question_sub_type') === 'face') {
                    return 'Faces';
                } else if (this.get('question_sub_type') === 'number') {
                    return 'Number';
                } else if (this.get('question_sub_type') === 'heart') {
                    return 'Hearts';
                } else if (this.get('question_sub_type') === 'thumb') {
                    return 'Thumbs';
                } else {
                    return 'Rating Scale';
                }
            case 'long':
                return 'Long Answer';
            case 'short':
                return 'Short Answer';
            case 'thankyou':
                return 'Thank You';
            default:
                return '';
        }
    },

    getQuestionType: function() {
        var question_type = this.get('question_type');

        if (question_type === 'short') {
            return 'Short Answer';
        } else if (question_type === 'long') {
            return 'Long Answer';
        } else if (question_type === 'multiple') {
            return 'Multiple Choice';
        } else if (question_type === 'dropdown') {
            return 'Dropdown';
        } else if (question_type === 'yesno') {
            return 'Yes or No';
        } else if (question_type === 'rating') {
            return 'Rating';
        } else if (question_type === 'nps') {
            return 'Net Promoter Score&#174;';
        } else if (question_type === 'thankyou') {
            return 'Thank you';
        } else if (question_type === 'welcome') {
            return 'Welcome';
        } else {
            return '';
        }
    },

    getQuestionCategory: function() {
        var question_type = this.get('question_type');

        switch (question_type) {
            case 'welcome':
                return 'intro';
            case 'short':
            case 'long':
                return 'text';
            case 'multiple':
            case 'dropdown':
            case 'yesno':
                return 'selection';
            case 'rating':
            case 'nps':
                return 'poll';
            case 'thankyou':
                return 'thankyou';
            default:
                return '';
        }
    }
});

export default Survey_Question;